import styled from 'styled-components'

import { Flex } from '@h2/components/layout/flex'
import completedLessonsSVG from '@h2/assets/svg/illustrations/navianceElementary/lessons/lessonsCompleted.svg'

const FullWidthFlex = styled(Flex)`
  width: 100%;
  > img {
    margin: -20px;
  }
`
const SpaceFlex = styled(Flex)`
  flex: auto;
  width: 100%;
  justify-content: space-between;
  flex-direction: row;
`
const LessonMessageContainer = ({ children }) => {
  return (
    <FullWidthFlex wrap="wrap" direction="column">
      <SpaceFlex direction="row" wrap="wrap">
        {children}
      </SpaceFlex>
      <img
        src={completedLessonsSVG}
        alt={'illustration of a diverse group of career professionals'}
      />
    </FullWidthFlex>
  )
}

export { LessonMessageContainer }
